import { Swal } from '@/plugins/sweetalert2'
import { getElementById } from '@/helpers/DOM'
import lang from '@/plugins/lang'
import { isMobile } from '@/helpers/browser'

export class HighlightFormInvalid {
    /**
     * @type {HTMLElement|null}
     */
    #firstErrorInput = null

    constructor(displayAlert = true) {
        this.displayAlert = displayAlert
    }

    highlightForm(errors, form) {
        this.#firstErrorInput = null

        this.form = getElementById(form)

        this.alreadyFocused = false

        this.clearDivInvalidContent()

        if (typeof errors !== 'object')
            return

        for (let field in errors) {
            this.showInputError(field, errors[field])
        }

        if (this.displayAlert) {
            Swal.fire({
                title: lang.t('error_http:wrong_input_title'),
                text: lang.t('error_http:422'),
                icon: 'warning'
            })
        }

        this.focusFirstError()
    }

    showInputError(inputName, error, inputPosition = null) {
        let nameSpliter = this.splitInputFromResponse(inputName)

        if (nameSpliter.length === 0) return

        if (nameSpliter.length === 1) {
            let inputs = this.form.querySelectorAll(`[name="${nameSpliter[0]}"]`)

            if (inputs.length === 1) {
                this.highlightInputSimple(inputs[0], error)

                return
            }

            if(inputs.length > 1 && inputPosition !== null) {
                this.highlightInputSimple(inputs[inputPosition], error, inputPosition)

                return
            }

            if (inputs.length > 1) {
                this.highlightInputMultiple(inputs, error, nameSpliter[0])

                return
            }

            inputs = this.form.querySelectorAll(`[name^="${nameSpliter[0]}["]`)

            if (inputs.length === 0) {
                console.warn("Não foi possivel localizar o input para o erro:", error)

                return
            }

            this.highlightInputMultiple(inputs, error, nameSpliter[0])

            return
        }

        let inputs = this.form.querySelectorAll(`[name^="${nameSpliter[0]}[]"]`)

        if (parseInt(nameSpliter[1]) < inputs.length) {
            let name = nameSpliter.shift()

            let inputPosition = parseInt(nameSpliter.shift()) + (inputPosition || 0)

            let concat =  nameSpliter.length > 0 ? ('.' + nameSpliter.join('.') ) : ''

            this.showInputError(name + '[]' + concat, error, inputPosition)

            return
        }

        let newName = nameSpliter.shift()

        let key = nameSpliter.shift()

        let concat =  nameSpliter.length > 0 ? ('.' + nameSpliter.join('.') ) : ''

        let name = newName + '[' + key + ']' + concat

        this.showInputError(name, error, inputPosition)

        return
    }

    highlightInputSimple(input, error, position = null) {
        let div = position === null ? this.getDivInvalid(input) : this.getDivInvalidByPosition(input, position)

        this.insertMessageToDiv(div, error)

        this.highlightInput(input)
    }

    highlightInputMultiple(inputs, error, inputName) {
        // A mensagem de erro referente a todos os inputs será inserido em baixo do ultimo input
        // ou na posição da div.is-invalid que foi localizada
        let div = this.form.querySelector(`div[for="${inputName}"]`) ?? this.getDivInvalid(inputs[inputs.length - 1])

        this.insertMessageToDiv(div, error)

        // Highlight todos os inputs para alertar o cliente
        inputs.forEach(i => this.highlightInput(i))
    }

    highlightInput(input) {
        if (input.parentElement.className.includes('choices__inner')) {
            input = input.parentElement

            let label = input.parentElement.parentElement

            input = label.className.includes('form-label-input') ? label : input
        } else if (input.parentElement.className.includes('form-label-input')) {
            input.parentElement.classList.add('is-invalid')
        }

        input.classList.add('is-invalid')
    }

    insertMessageToDiv(div, error) {
        div.textContent = ''

        error.forEach(err => {
            let divText = document.createElement('div')
            divText.textContent = err
            div.append(divText)
        })

        div.classList.add('active')
    }

    focusFirstError() {
        let element = this.getFirstInputError()

        if (!element) {
            return
        }

        let elementTop = element.getBoundingClientRect().top

        if (elementTop === 0) {
            return
        }

        let adjust = isMobile() ? 100 : 30

        window.scrollTo(0, elementTop + window.scrollY - adjust)
    }

    insertDivInvalid(input) {
        let div = document.createElement('div')
        div.className = 'invalid-feedback'
        div.setAttribute('for', input.name)

        let parentClassName = input.parentElement.className

        if (parentClassName.includes('form-label-input') || parentClassName.includes('custom-control')) {
            input.parentElement.insertAdjacentElement('afterend', div)
        } else {
            input.insertAdjacentElement('afterend', div)
        }

        return div
    }

    getDivInvalid(input) {
        return this.form.querySelector(`div[for="${input.name}"]`) ?? this.insertDivInvalid(input)
    }

    getDivInvalidByPosition(input, position) {
        let inputs =  this.form.querySelectorAll(`div[for="${input.name}"]`)

        if (inputs.length < position) {
            return inputs[position]
        }

        return this.insertDivInvalid(input)
    }

    splitInputFromResponse(name) {
        return name.split('.')
    }

    clearDivInvalidContent()
    {
        this.form.querySelectorAll('.invalid-feedback').forEach(el => el.textContent = '')
    }

    setForm(form)
    {
        this.form = form
    }

    /**
     * @return {HTMLElement|null}
     */
    getFirstInputError() {
        return this.#firstErrorInput || this.form?.querySelector('.is-invalid') || this.form?.querySelector('.invalid-feedback.active')
    }
}

export function clearHighlightFormError(form) {
    form = getElementById(form)
    form.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid'))
    form.querySelectorAll('.invalid-feedback').forEach(el => el.classList.remove('active'))
}
